import type { RecordFormData } from './types';

export const validateRecordForm = (formData: RecordFormData): Record<string, string> => {
  const errors: Record<string, string> = {};

  if (!formData.name.trim()) errors.name = 'Name is required';
  if (!formData.type) errors.type = 'Type is required';

  const t = formData.type.toUpperCase();
  const hasValue = !!formData.value.trim();

  // SRV requires target in value
  if (t === 'SRV' && !hasValue) errors.value = 'Target is required for SRV';

  // For structured types, allow empty value when structured fields are complete; otherwise require value
  const hasCAA = formData.caa_flags !== '' && !!formData.caa_tag && !!formData.caa_value;
  const hasDS =
    formData.ds_key_tag !== '' &&
    formData.ds_algorithm !== '' &&
    formData.ds_digest_type !== '' &&
    !!formData.ds_digest;
  const hasTLSA =
    formData.tlsa_usage !== '' &&
    formData.tlsa_selector !== '' &&
    formData.tlsa_matching_type !== '' &&
    !!formData.tlsa_data;
  const hasSSHFP =
    formData.sshfp_algorithm !== '' && formData.sshfp_type !== '' && !!formData.sshfp_fingerprint;
  const hasNAPTR =
    formData.naptr_order !== '' &&
    formData.naptr_preference !== '' &&
    !!formData.naptr_flags &&
    !!formData.naptr_service &&
    !!formData.naptr_regexp &&
    !!formData.naptr_replacement;

  if (['CAA', 'DS', 'TLSA', 'SSHFP', 'NAPTR'].includes(t)) {
    if (!hasValue && !(hasCAA || hasDS || hasTLSA || hasSSHFP || hasNAPTR))
      errors.value = `${t} requires a value or full structured fields`;
  } else if (!(t === 'SRV')) {
    if (!hasValue) errors.value = 'Value is required';
  }

  if (!formData.ttl || isNaN(parseInt(formData.ttl)) || parseInt(formData.ttl) < 1)
    errors.ttl = 'TTL must be a positive number';

  if (formData.type === 'MX' && formData.priority && isNaN(parseInt(formData.priority)))
    errors.priority = 'Priority must be a number';

  if (formData.type === 'SRV') {
    if (!formData.priority || isNaN(parseInt(formData.priority)))
      errors.priority = 'Priority is required for SRV records';
    if (!formData.weight || isNaN(parseInt(formData.weight)))
      errors.weight = 'Weight is required for SRV records';
    if (!formData.port || isNaN(parseInt(formData.port)))
      errors.port = 'Port is required for SRV records';
  }

  return errors;
};